export const LumenBrand = ({ compact = false, testId = "lumen-brand" }) => (
  <div className={`flex items-center ${compact ? "gap-0" : "gap-0.5"}`} data-testid={testId}>
    <div className={`${compact ? "h-11 w-11" : "h-16 w-16"} overflow-hidden`} data-testid={`${testId}-logo-wrap`}>
      <img
        alt="Lumen TMS logo"
        className={`h-full w-full ${compact ? "scale-[1.42]" : "scale-[1.36]"} object-contain brightness-120 contrast-135 saturate-[1.7] drop-shadow-[0_0_10px_rgba(248,163,72,0.18)]`}
        data-testid={`${testId}-logo`}
        src="/lumen-logo.png"
      />
    </div>
    <div className={`min-w-0 ${compact ? "-ml-1" : "-ml-1.5"}`}>
      <h1
        className={`${compact ? "text-[1.92rem]" : "text-[2rem]"} whitespace-nowrap font-black leading-none`}
        data-testid={`${testId}-text`}
        style={{
          fontFamily: '"Trebuchet MS", "Segoe UI", sans-serif',
          color: "#1f2937",
          letterSpacing: "-0.02em",
          textShadow: "0 1px 0 rgba(255,255,255,0.55), 0 2px 0 rgba(203,213,225,0.55), 0 8px 18px rgba(15,23,42,0.18)",
        }}
      >
        Lumen TMS
      </h1>
    </div>
  </div>
);